import { Role } from '../../../../types/auth';

export const getData = (t: (key: string) => string) => [
  {
    title: t('pages:workOrders.generalView'),
    path: '',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
    subItems: [
      {
        text: t('pages:workOrders.newOrder'),
        path: 'new-order',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
      },
      {
        text: t('pages:workOrders.duplicateOrder'),
        path: 'duplicate-order',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
      },
    ],
  },
  {
    title: t('pages:campaigns.title'),
    path: 'campaign',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
    subItems: [
      {
        text: t('pages:campaigns.new'),
        path: 'campaign/new-campaign',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
      },
    ],
  },
  {
    title: t('pages:workOrders.actionsValidation'),
    path: 'actions-validation',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin],
  },
];

// Para compatibilidad con imports existentes - usar valores por defecto
export const data = [
  {
    title: 'Vista general d´O.T.',
    path: '',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
    subItems: [
      {
        text: 'Nova O.T',
        path: 'new-order',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
      },
      {
        text: 'Duplicar O.T.',
        path: 'duplicate-order',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
      },
    ],
  },
  {
    title: 'Campanyes',
    path: 'campaign',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
    subItems: [
      {
        text: 'Nova campanya',
        path: 'campaign/new-campaign',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.Tablet, Role.RoomTeam],
      },
    ],
  },
  {
    title: "Validacio d'actuacions",
    path: 'actions-validation',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin],
  },
];
